import React, { useEffect, useState } from "react";
import "./css/screen3.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import tncEn from "locales/tnc/tnc.en.json";
import tncFr from "locales/tnc/tnc.fr.json";
import { Interweave } from "interweave";

const languageMap = new Map([
  ["0", tncEn],
  ["1", tncFr]
]);

const Tnc = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tnc, setTnc] = useState({});

  useEffect(() => {
    const languageId = localStorage.getItem("selectedLanguage");
    const mappedTnc = languageMap.get(languageId);

    if (mappedTnc) {
      setTnc(mappedTnc);
    } else {
      setTnc(languageMap.get("1"));
    }
  }, []);

  return (
    <div className="home">
      <div className="main">
        <div className="container-fluid box-wrapper difficult">
          <div className="page-header pb-5">
            <div className="box-wrapper mx-auto text-center position-relative header-container">
              <button type="button" className="icon-button" onClick={() => navigate(-1)}>
                <img src="/image/back.png" className="arrow" alt="back" />
              </button>
              <span className="levels-title">{t("106")}</span>
            </div>
          </div>
          <div className="home-profile">
            <h4 className="text-center">{tnc.heading}</h4>
            <div className="my-4">
              {tnc?.subheadings?.map((section) => (
                <div key={section.id} className="mb-3">
                  {section.id ? (
                    <h6>
                      {section.id}. {section.title}
                    </h6>
                  ) : (
                    <h6>{section.title}</h6>
                  )}
                  {section.subheadings.map((subsection, i) => (
                    <p key={subsection.id + i} className="tnc-description mb-0">
                      <span className={subsection.tabbed ? "ms-3" : ""}>
                        {subsection.isHTML ? (
                          <Interweave content={subsection.id} />
                        ) : subsection.id ? (
                          `${subsection.id}. `
                        ) : (
                          ""
                        )}
                      </span>
                      <span>
                        {subsection.isHTML ? (
                          <Interweave content={subsection.content} />
                        ) : (
                          `${subsection.content}`
                        )}
                      </span>
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tnc;
